<template>
    <div class="font-weight-medium" >
        <v-chip class="mb-2">
            {{ formatName() }}
        </v-chip>
    </div>
</template>
<script>
export default {
    name: 'CityName',
    props: {
        name: {
          required:true,
          type: String
        }
    },
    methods: {
        formatName() {
            var name = this.name.substring(0, 1).toUpperCase() + this.name.substring(1).toLowerCase()
            return name
        }
    }
}
</script>
